import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { Button, Dialog, DialogSurface, DialogBody, DialogTitle, DialogContent } from "@fluentui/react-components";
import { DismissRegular } from "@fluentui/react-icons";
import { Header } from "./Header";
import { Sidenav } from "./Sidenav";
import { ErrorBoundary } from "./ErrorBoundary";
import { usePoolBrowsing } from "../contexts/PoolBrowsingContext";
import { useViewPreferences } from "../contexts/ViewPreferencesContext";

export function AppShell({ children }) {
    const [navOpen, setNavOpen] = useState(false);
    const location = useLocation();
    const { listHref } = usePoolBrowsing();
    const { view } = useViewPreferences();
    const main = useRef();
    const pageView = location.pathname === "/" || /^\/pools(?:\/|$)/.test(location.pathname) ? view : "standard";

    useEffect(() => { setNavOpen(false); }, [location.pathname]);
    useLayoutEffect(() => {
        if (location.pathname.startsWith("/pools/") && location.pathname !== "/pools/") main.current.scrollTop = 0;
    }, [location.pathname]);

    return (
        <Dialog open={navOpen} onOpenChange={(_, data) => setNavOpen(data.open)}>
            <div className="app-shell">
                <a href="#main-content" className="skip-link">Skip to content</a>
                <aside className="sidenav"><Sidenav poolListHref={listHref} /></aside>
                <header className="header"><Header navOpen={navOpen} /></header>
                <main className="main" id="main-content" tabIndex={-1} ref={main}>
                    <div className={`page-container${pageView === "compact" ? " page-container--compact" : ""}`} data-view={pageView}>
                        <ErrorBoundary key={location.pathname}>{children}</ErrorBoundary>
                    </div>
                </main>
            </div>
            <DialogSurface className="mobile-navigation">
                <DialogBody>
                    <DialogTitle action={<Button appearance="subtle" icon={<DismissRegular />} aria-label="Close navigation" onClick={() => setNavOpen(false)} />}>
                        Navigation
                    </DialogTitle>
                    <DialogContent><Sidenav poolListHref={listHref} onNavigate={() => setNavOpen(false)} /></DialogContent>
                </DialogBody>
            </DialogSurface>
        </Dialog>
    );
}
